
import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} params
 */
 export const scratchWorkList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.project/workListByScrach',
    params
  })
}